module.exports = __webpack_public_path__ + "static/media/sortLowToHigh.89bd8de9.svg";